import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Selectors
import * as OnboardingStateSelectors from 'Shared/selectors/OnboardingState.selectors';

// Actions
import { updateOnboardingState } from 'Shared/actions/onboardingState';

// Constants
import TopicsConstants from './Topics.constants';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import { WpCollapsible } from 'Wpds/components/collapsible';

// Styles
import './SuggestedTopics.scss';

const SubTopicItem = ({ subtopic, parentTopic }) => {
  const dispatch = useDispatch();
  const topics = useSelector(state => OnboardingStateSelectors.getDiscussionTopics(state));
  const baseClassName = 'SuggestedTopics';
  const handleAddTopic = useCallback(
    topicItem => {
      (window as any).analytics.track('Used suggested topic in agenda builder (onboarding)', { category: parentTopic });
      dispatch(
        updateOnboardingState({
          onboardingState: {
            discussion_topics: [...topics, topicItem.name],
          },
        })
      );
    },
    [topics]
  );

  return (
    <div className={`${baseClassName}__subtopic`} onClick={() => handleAddTopic(subtopic)}>
      {' '}
      <div className={`${baseClassName}__subtopic__icon`}>
        <WpIcon name="plus-circle" />
      </div>
      {subtopic.name}
    </div>
  );
};

const SuggestedTopics = React.memo(() => {
  const baseClassName = 'SuggestedTopics';

  const TopicListItem = ({ topic, index, isOpen, setOpen }) => {
    return (
      <div className={`${baseClassName}__topic`} key={topic.name}>
        <WpButton
          variant="tertiary"
          onClick={() => {
            setOpen(index);
          }}
        >
          {isOpen ? <WpIcon name="chevron-down" /> : <WpIcon name="chevron-right" />}
          {topic.name}
        </WpButton>
        <WpCollapsible open={isOpen}>
          <div className={`${baseClassName}__topic__subtopics`}>
            {topic.subtopics.map(subtopic => {
              return <SubTopicItem subtopic={subtopic} key={subtopic.name} parentTopic={topic.name} />;
            })}
          </div>
        </WpCollapsible>
      </div>
    );
  };

  const TopicsList = () => {
    const [openTopicsList, setOpenTopicsList] = useState(0);
    return TopicsConstants.map((topic, index) => {
      return (
        <TopicListItem
          topic={topic}
          index={index}
          key={topic.name}
          isOpen={openTopicsList === index}
          setOpen={setOpenTopicsList}
        />
      );
    });
  };

  return (
    <div className={baseClassName}>
      <p className={`${baseClassName}__title`}>Suggested Topics</p>
      <TopicsList />
    </div>
  );
});

export default SuggestedTopics;
